module.exports = __webpack_public_path__ + "pagerduty-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/pagerduty-logo.png
// module id = 1262
// module chunks = 74